"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = void 0;
Object.defineProperty(exports, "Collapse", {
  enumerable: true,
  get: function () {
    return _material.Collapse;
  }
});
exports.Toggler = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _material = require("@mui/material");
var _IconButton = require("../Buttons/IconButton");
var _Icon = require("../Basics/Icons/Icon");
var _common = require("../styles/common");
const _excluded = ["expand", "children", "variant"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const SToggler = _styledComponents.default.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    text-transform: uppercase;
    height: 50px;
    flex-shrink: 0;

    ${(0, _common.hoverAnimation)()}

    ${({
  variant
}) => {
  if (variant === 'secondary') {
    return (0, _styledComponents.css)`
                color: var(--text-secondary-color);
                font-weight: 500;
        `;
  } else {
    return (0, _styledComponents.css)`
                font-weight: bold;
        `;
  }
}}
`;
const Arrow = (0, _styledComponents.default)(_IconButton.IconButton)`
    margin-right: 4px;
    transition: transform .25s ease-in;
    transform: ${props => !props.expand ? 'rotate(0deg)' : 'rotate(90deg)'};
`;
exports.Arrow = Arrow;
const Toggler = _ref => {
  let {
      expand,
      children,
      variant = 'primary'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(SToggler, _extends({
    expand: expand,
    variant: variant
  }, rest), /*#__PURE__*/_react.default.createElement(Arrow, {
    expand: expand,
    disableHoverAnimation: true
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "right-arrow",
    size: "sm"
  })), children);
};
exports.Toggler = Toggler;
Toggler.propTypes = {
  expand: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['primary', 'secondary'])
};